const MORSE_TABLE: Record<string, string> = {
  A: '.-',
  B: '-...',
  C: '-.-.',
  D: '-..',
  E: '.',
  F: '..-.',
  G: '--.',
  H: '....',
  I: '..',
  J: '.---',
  K: '-.-',
  L: '.-..',
  M: '--',
  N: '-.',
  O: '---',
  P: '.--.',
  Q: '--.-',
  R: '.-.',
  S: '...',
  T: '-',
  U: '..-',
  V: '...-',
  W: '.--',
  X: '-..-',
  Y: '-.--',
  Z: '--..',
  '0': '-----',
  '1': '.----',
  '2': '..---',
  '3': '...--',
  '4': '....-',
  '5': '.....',
  '6': '-....',
  '7': '--...',
  '8': '---..',
  '9': '----.'
}

/**
 * Converte o designador de um navaid (ex.: "CGO") na sequência Morse por caractere
 * (ex.: ["-.-.", "--.", "---"]). Caracteres fora da tabela A-Z/0-9 são descartados.
 * Tabela conforme AIP Brasil GEN 2.6 (idêntica à ITU).
 */
export const encodeMorse = (code: string): string[] => {
  if (!code) return []
  return code
    .toUpperCase()
    .split('')
    .map((char) => MORSE_TABLE[char] ?? '')
    .filter((sequence) => sequence.length > 0)
}
